import { FunctionComponent } from "react"
import { useNavigate } from "react-router-dom"

// Check environment for payment bypass
// Payment bypass is DISABLED by default and only enabled in:
// 1. Development mode (NODE_ENV === "development")
// 2. Staging environment (hostname includes "staging")
// 3. Explicit opt-in via REACT_APP_BYPASS_TEAM_SIM_PAYMENT=true
const isStaging = typeof window !== "undefined" && window.location.hostname.includes("staging")
const isDevelopment = process.env.NODE_ENV === "development"
const isExplicitBypass = process.env.REACT_APP_BYPASS_TEAM_SIM_PAYMENT === "true"

const BYPASS_PAYMENT = isDevelopment || isStaging || isExplicitBypass

const TeamSimulationsSection: FunctionComponent = () => {
  const navigate = useNavigate()

  const handleConfigureClick = () => {
    // Navigate to the purchase page (which handles payment and then setup)
    navigate("/admin/team-simulations/purchase")
  }

  return (
    <div className="min-h-full bg-gray-50 py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 bg-[#faaa32]/10 rounded-lg flex items-center justify-center mr-4">
              <svg className="w-6 h-6 text-[#faaa32]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">Team Dynamics Assessment</h1>
            </div>
          </div>

          <p className="text-gray-600 leading-relaxed mb-4">
            You&apos;ve mapped how your people think as individuals. Now reveal how they think together.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            Run a collaborative simulation with any group and observe the dynamics before they play out on real projects:
          </p>

          <ul className="space-y-2 mb-6 text-gray-600">
            <li className="flex items-start">
              <span className="text-[#faaa32] mr-2">•</span>
              How information flows between team members
            </li>
            <li className="flex items-start">
              <span className="text-[#faaa32] mr-2">•</span>
              Where friction or misalignment will likely emerge
            </li>
            <li className="flex items-start">
              <span className="text-[#faaa32] mr-2">•</span>
              Who naturally drives decisions vs. who holds back
            </li>
            <li className="flex items-start">
              <span className="text-[#faaa32] mr-2">•</span>
              How different cognitive styles interact under pressure—before it happens on real projects
            </li>
          </ul>

          <p className="text-gray-500 text-sm mb-6 italic">
            Ideal before launching a new initiative, restructuring a team, or integrating new members. See the dynamics before they play out.
          </p>

          <div className="flex flex-col items-start">
            <button
              onClick={handleConfigureClick}
              className="px-5 py-2.5 bg-[#faaa32] text-white text-sm font-medium rounded-lg hover:bg-[#e09a2a] transition-colors mb-2"
            >
              Configure Team Simulation
            </button>
            <span className="text-gray-500 text-sm">
              $199 for up to ten team members
            </span>
            {BYPASS_PAYMENT && (
              <span className="mt-2 px-2 py-1 bg-[#ffca4b]/30 text-[#3d5669] text-xs font-medium rounded">
                {isDevelopment ? "DEV" : "STAGING"} MODE: Payment Bypassed
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamSimulationsSection
